import type { ShuttleStop } from "./ShuttleRouteMap";

export const externoRoute: [number, number][] = [
  [9.066587549136555, -79.38768169846611],
  [9.066746470927077, -79.38759050336415],
  [9.066923933510042, -79.38749126163555],
  [9.06711993685793, -79.3873839732803],
  [9.067286804488713, -79.38729546038722],
  [9.067419239061094, -79.38723376958295],
  [9.0675119432327, -79.3871693965698],
  [9.067633782964704, -79.3871130701833],
  [9.0677, -79.387052],
  [9.06791, -79.386926],
  [9.068182, -79.386926],
  [9.068325, -79.387092],
  [9.068482, -79.387357],
  [9.068619, -79.387618],
  [9.068723, -79.387883],
  [9.068863, -79.388149],
  [9.068985, -79.388237],
  [9.069131, -79.388296],
  [9.069263, -79.388401],
  [9.069316, -79.388572],
  [9.069056, -79.388709],
  [9.068879, -79.388583],
  [9.068709, -79.388511],
  [9.068537, -79.388578],
  [9.068352, -79.388696],
  [9.068106, -79.388859],
  [9.067873, -79.389015],
  [9.067639, -79.389136],
  [9.067473, -79.389238],
  [9.067377, -79.389388],
  [9.066924, -79.389661],
  [9.066779, -79.389675],
  [9.066651, -79.389745],
  [9.066485, -79.38983],
  [9.06627, -79.389951],
  [9.066127, -79.39001],
  [9.066039618950732, -79.3899537859381],
  [9.06597605011782, -79.38981967549404],
  [9.06584891241823, -79.38956486565034],
  [9.065674097983376, -79.38931542024692],
  [9.065475445140947, -79.38915985213181],
  [9.065335063732691, -79.38925104723377],
  [9.065149654241447, -79.38936906442456],
  [9.065019867540634, -79.38944953069098],
  [9.064805322075193, -79.38957291229951],
  [9.06462520973364, -79.38968288286364],
  [9.06440006917965, -79.38979821784552],
  [9.064235848921848, -79.38988136632084],
  [9.064315, -79.390007],
  [9.064487, -79.390085],
  [9.064678, -79.390184],
  [9.064872, -79.390407],
  [9.065015, -79.390665],
  [9.065184, -79.390952],
  [9.065298, -79.391172],
  [9.065404, -79.391408],
  [9.065552, -79.391646],
  [9.065605, -79.391727],
  [9.065852, -79.391579],
  [9.066151, -79.39141],
  [9.066432, -79.391241],
  [9.066704, -79.391102],
  [9.067012, -79.390909],
  [9.067194, -79.390769],
  [9.067369, -79.390442],
  [9.067526, -79.390107],
  [9.067663, -79.389817],
  [9.067918, -79.389519],
  [9.0681, -79.389356],
  [9.068323, -79.389133],
  [9.068315, -79.388943],
  [9.068167, -79.388873],
  [9.068029, -79.388913],
  [9.067806, -79.389018],
  [9.067555, -79.389168],
  [9.067383, -79.389278],
  [9.067255, -79.389372],
  [9.067059, -79.389348],
  [9.066924, -79.38923],
  [9.066797, -79.389045],
  [9.066681, -79.388835],
  [9.066524, -79.388562],
  [9.066389, -79.388323],
  [9.066307, -79.388082],
  [9.066289, -79.387969],
  [9.066283, -79.387864],
  [9.066482, -79.387736],
  [9.066609089259975, -79.38767122619244],
];

const EXTERNO_T1_MAP_URL =
  "https://airportpanama.lmp.prod.livingmap.com/poi/?feature=9ea21059865cec9b9f187d31535ebdd2&floor=1&lang=en-GB#18/9.066832/-79.38747/119";
const EXTERNO_METRO_MAP_URL =
  "https://airportpanama.lmp.prod.livingmap.com/poi/?feature=6ee3c5ac3b566ef6ad673577fb0546d4&floor=1&lang=en-GB#17/9.065927/-79.389935/119";
const EXTERNO_T2_MAP_URL =
  "https://airportpanama.lmp.prod.livingmap.com/poi/?feature=ad6afe0a1b1786a9f38385fe1784dbbd&floor=1&lang=en-GB#18/9.064054/-79.3902/119";

// El nombre de la parada sale de i18n (shuttlePage.stops); acá sólo viven
// coordenadas y enlaces, que son iguales en todos los idiomas.
export const externoStops: ShuttleStop[] = [
  {
    position: [9.066923933510042, -79.38749126163555],
    nameKey: "externoT1",
    mapUrl: EXTERNO_T1_MAP_URL,
  },
  {
    position: [9.06584891241823, -79.38956486565034],
    nameKey: "externoMetro",
    mapUrl: EXTERNO_METRO_MAP_URL,
  },
  {
    position: [9.064235848921848, -79.38988136632084],
    nameKey: "externoT2",
    mapUrl: EXTERNO_T2_MAP_URL,
  },
];

export const internoRoute: [number, number][] = [
  [9.07092909, -79.385345],
  [9.07071813, -79.385276],
  [9.07064018, -79.385427],
  [9.07033458, -79.385554],
  [9.06990381, -79.385789],
  [9.06954624, -79.385984],
  [9.06932596, -79.386087],
  [9.06915645, -79.385973],
  [9.06917689, -79.38577],
  [9.069066, -79.385361],
  [9.06887405, -79.385044],
  [9.06860877, -79.384569],
  [9.06834756, -79.384373],
  [9.06802086, -79.384336],
  [9.0678611, -79.38442],
  [9.06746108, -79.384648],
  [9.06724604, -79.384794],
  [9.06723507, -79.385015],
  [9.06744013, -79.38543],
  [9.06756226, -79.385672],
  [9.06762083, -79.385968],
  [9.06746174, -79.386153],
  [9.06710035, -79.386357],
  [9.06659663, -79.386641],
  [9.06606962, -79.386938],
  [9.06577386, -79.387104],
  [9.06569275, -79.387194],
  [9.06560973, -79.387492],
  [9.065549, -79.387895],
  [9.0657161, -79.388082],
  [9.06585404, -79.388287],
  [9.06578417, -79.388519],
  [9.06550365, -79.388688],
  [9.06513628, -79.388975],
  [9.06482119, -79.389161],
  [9.06442723, -79.38933],
  [9.0640461, -79.389407],
  [9.06346396, -79.389489],
  [9.06295388, -79.389443],
  [9.06260842, -79.389392],
  [9.06238744, -79.389411],
  [9.06223903, -79.389526],
  [9.06222251, -79.389518],
  [9.06206054, -79.389916],
  [9.06182116, -79.390368],
  [9.06161781, -79.390725],
  [9.06146347, -79.390771],
  [9.06126731, -79.390526],
  [9.06105769, -79.390232],
  [9.06097086, -79.39009],
  [9.06113117, -79.389837],
  [9.06145807, -79.389327],
  [9.06203347, -79.388751],
  [9.0627049, -79.388597],
  [9.06367954, -79.388431],
  [9.06422133, -79.388387],
  [9.06485452, -79.388396],
  [9.06517842, -79.388477],
  [9.06542896, -79.388633],
  [9.06564428, -79.388587],
  [9.0658585, -79.388421],
  [9.06588502, -79.388186],
  [9.06559221, -79.388014],
  [9.06551975, -79.387873],
  [9.06561681, -79.387395],
  [9.06568721, -79.387109],
  [9.06595286, -79.386997],
  [9.06661676, -79.386607],
  [9.06728316, -79.38627],
  [9.06758754, -79.38611],
  [9.06760062, -79.385854],
  [9.06754834, -79.385638],
  [9.06720456, -79.384877],
  [9.06736316, -79.384688],
  [9.06801177, -79.384342],
  [9.06859604, -79.384558],
  [9.06899047, -79.385133],
  [9.06872414, -79.385621],
  [9.06851051, -79.386288],
  [9.06876011, -79.386369],
  [9.06920688, -79.386161],
  [9.06929096, -79.386141],
  [9.06943265, -79.386401],
  [9.07015965, -79.385971],
  [9.07068315, -79.385685],
  [9.071004, -79.385512],
  [9.07103574, -79.385417],
];

const INTERNO_T2_MAP_URL =
  "https://airportpanama.lmp.prod.livingmap.com/poi/?feature=fb9f472e59a1e6aa0a21db66769cf19a";
const INTERNO_T1_MAP_URL =
  "https://airportpanama.lmp.prod.livingmap.com/poi/?feature=7e5359c856605c3f14bbf48be5525bf6&floor=2&lang=en-GB#18/9.070871/-79.3855/119";

export const internoStops: ShuttleStop[] = [
  {
    position: [9.06223903, -79.389526],
    nameKey: "internoT2",
    mapUrl: INTERNO_T2_MAP_URL,
  },
  {
    position: [9.07103574, -79.385417],
    nameKey: "internoT1",
    mapUrl: INTERNO_T1_MAP_URL,
  },
];

/* ----------------------- Bus animation / schedule ----------------------- */

const PANAMA_OFFSET_HOURS = -5;
const SERVICE_START_HOUR = 5;
const SERVICE_END_HOUR = 23;

export function getPanamaServiceElapsedMs(now: Date): number {
  const utcMs = now.getTime();
  const panamaShifted = new Date(utcMs + PANAMA_OFFSET_HOURS * 3600 * 1000);
  const y = panamaShifted.getUTCFullYear();
  const m = panamaShifted.getUTCMonth();
  const d = panamaShifted.getUTCDate();
  const serviceStartUtcMs = Date.UTC(
    y,
    m,
    d,
    SERVICE_START_HOUR - PANAMA_OFFSET_HOURS,
    0,
    0,
  );
  return utcMs - serviceStartUtcMs;
}

export function getPanamaMinutesOfDay(now: Date): number {
  const utcMs = now.getTime();
  const panamaShifted = new Date(utcMs + PANAMA_OFFSET_HOURS * 3600 * 1000);
  return (
    panamaShifted.getUTCHours() * 60 +
    panamaShifted.getUTCMinutes() +
    panamaShifted.getUTCSeconds() / 60
  );
}

export function isServiceOpenPanama(now: Date): boolean {
  const minutes = getPanamaMinutesOfDay(now);
  return minutes >= SERVICE_START_HOUR * 60 && minutes < SERVICE_END_HOUR * 60;
}

function cumulativeDistances(path: [number, number][]): number[] {
  const cum: number[] = [0];
  for (let i = 1; i < path.length; i++) {
    const dy = path[i][0] - path[i - 1][0];
    const dx = path[i][1] - path[i - 1][1];
    cum.push(cum[i - 1] + Math.hypot(dx, dy));
  }
  return cum;
}

function pointAtProgress(
  path: [number, number][],
  cum: number[],
  progress: number,
): [number, number] {
  const total = cum[cum.length - 1];
  if (total === 0) return path[0];
  const clamped = Math.max(0, Math.min(1, progress));
  const target = clamped * total;
  let lo = 0;
  let hi = cum.length - 1;
  while (lo < hi - 1) {
    const mid = (lo + hi) >> 1;
    if (cum[mid] <= target) lo = mid;
    else hi = mid;
  }
  const segLen = cum[hi] - cum[lo];
  const t = segLen > 0 ? (target - cum[lo]) / segLen : 0;
  return [
    path[lo][0] + (path[hi][0] - path[lo][0]) * t,
    path[lo][1] + (path[hi][1] - path[lo][1]) * t,
  ];
}

export interface BusInstance {
  id: string;
  getPosition: (now: Date) => [number, number];
}

/* -------- External shuttle ---------------------------------------------
 * The polyline is split in two halves at the T2 stop:
 *  - Forward half (T1 → Metro → T2): 5 min trip
 *  - Return half  (T2 → T1, direct): 5 min trip
 * Each bus cycle = 20 min:
 *   0-5 : forward trip
 *   5-10: rest at T2
 *   10-15: return trip
 *   15-20: rest at T1
 * Two buses offset by 10 min ⇒ both depart together (one from T1, one
 * from T2), arrive together, rest together, and a departure from T1
 * happens every 10 min. */

const EXTERNO_T2_INDEX = 51;
const EXTERNO_FORWARD = externoRoute.slice(0, EXTERNO_T2_INDEX + 1);
const EXTERNO_RETURN = externoRoute.slice(EXTERNO_T2_INDEX);
const externoForwardCum = cumulativeDistances(EXTERNO_FORWARD);
const externoReturnCum = cumulativeDistances(EXTERNO_RETURN);
const EXTERNO_T1_POS = externoRoute[0];
const EXTERNO_T2_POS = externoRoute[EXTERNO_T2_INDEX];
const EXTERNO_TRIP_MS = 5 * 60 * 1000;
const EXTERNO_REST_MS = 5 * 60 * 1000;
const EXTERNO_CYCLE_MS = (EXTERNO_TRIP_MS + EXTERNO_REST_MS) * 2;
export const EXTERNO_INTERVAL_MINUTES = 10;

function externoBusPosition(now: Date, offsetMs: number): [number, number] {
  const elapsed = getPanamaServiceElapsedMs(now) - offsetMs;
  const phase =
    ((elapsed % EXTERNO_CYCLE_MS) + EXTERNO_CYCLE_MS) % EXTERNO_CYCLE_MS;
  if (phase < EXTERNO_TRIP_MS) {
    return pointAtProgress(
      EXTERNO_FORWARD,
      externoForwardCum,
      phase / EXTERNO_TRIP_MS,
    );
  }
  if (phase < EXTERNO_TRIP_MS + EXTERNO_REST_MS) {
    return EXTERNO_T2_POS;
  }
  if (phase < EXTERNO_TRIP_MS * 2 + EXTERNO_REST_MS) {
    return pointAtProgress(
      EXTERNO_RETURN,
      externoReturnCum,
      (phase - EXTERNO_TRIP_MS - EXTERNO_REST_MS) / EXTERNO_TRIP_MS,
    );
  }
  return EXTERNO_T1_POS;
}

export const externoBuses: BusInstance[] = [
  {
    id: "externo-A",
    getPosition: (now: Date) => externoBusPosition(now, 0),
  },
  {
    id: "externo-B",
    getPosition: (now: Date) =>
      externoBusPosition(now, EXTERNO_TRIP_MS + EXTERNO_REST_MS),
  },
];

/* -------- Internal shuttle: T1 ↔ T2 with rest at each terminal --------
 * Cycle = 30 min (12 min trip + 3 min rest + 12 min trip + 3 min rest).
 * Two buses offset by 15 min ⇒ a departure from T1 every 15 min. */

const INTERNO_T2_INDEX = 41;
const INTERNO_OUTBOUND = internoRoute.slice(0, INTERNO_T2_INDEX + 1);
const INTERNO_RETURN = internoRoute.slice(INTERNO_T2_INDEX);
const internoOutboundCum = cumulativeDistances(INTERNO_OUTBOUND);
const internoReturnCum = cumulativeDistances(INTERNO_RETURN);
const INTERNO_T1_POS = internoRoute[internoRoute.length - 1];
const INTERNO_T2_POS = internoRoute[INTERNO_T2_INDEX];
const INTERNO_TRIP_MS = 12 * 60 * 1000;
const INTERNO_REST_MS = 3 * 60 * 1000;
const INTERNO_CYCLE_MS =
  INTERNO_TRIP_MS * 2 + INTERNO_REST_MS * 2;
export const INTERNO_INTERVAL_MINUTES = 15;

function internoBusPosition(now: Date, offsetMs: number): [number, number] {
  const elapsed = getPanamaServiceElapsedMs(now) - offsetMs;
  const phase =
    ((elapsed % INTERNO_CYCLE_MS) + INTERNO_CYCLE_MS) % INTERNO_CYCLE_MS;
  if (phase < INTERNO_TRIP_MS) {
    return pointAtProgress(
      INTERNO_OUTBOUND,
      internoOutboundCum,
      phase / INTERNO_TRIP_MS,
    );
  }
  if (phase < INTERNO_TRIP_MS + INTERNO_REST_MS) {
    return INTERNO_T2_POS;
  }
  if (phase < INTERNO_TRIP_MS * 2 + INTERNO_REST_MS) {
    const localPhase =
      (phase - INTERNO_TRIP_MS - INTERNO_REST_MS) / INTERNO_TRIP_MS;
    return pointAtProgress(INTERNO_RETURN, internoReturnCum, localPhase);
  }
  return INTERNO_T1_POS;
}

export const internoBuses: BusInstance[] = [
  {
    id: "interno-A",
    getPosition: (now: Date) => internoBusPosition(now, 0),
  },
  {
    id: "interno-B",
    getPosition: (now: Date) => internoBusPosition(now, 15 * 60 * 1000),
  },
];
